import type { MemoryScope } from './memoryTypes';

/**
 * TanStack Query key factory for the /memory surface. Centralises the key
 * shapes so callers and tests can't drift.
 */
export const memoryKeys = {
  all: ['memory'] as const,
  list: (scope?: MemoryScope, sessionId?: string | null) =>
    [...memoryKeys.all, 'list', scope ?? '', sessionId ?? ''] as const,
};
